<template>
  <div class="auth-form__form-wrapper">
    <form
      @submit.prevent="validateFields"
      class="confirm-user reset-password ine-form__form auth-form__form"
    >
      <Title
        class="auth-form__title-wrapper auth-form__title-wrapper--compact"
        header="Confirm a User"
        tagline="Please enter the users email address"
      />
      <div
        v-for="(field, key) in fields"
        v-show="field.type"
        :key="`field-${key}`"
        class="auth-form__input-wrapper"
      >
        <input
          v-if="field.type"
          :type="field.type"
          :class="[
            'auth-form__form-control',
            'ine-input',
            errors.fields.includes(key) && 'ine-input--error',
          ]"
          @focus="clearErrors"
          :placeholder="field.placeholder"
          :autocomplete="field.autocomplete"
          v-model="field.value"
        />
        <Errors
          v-if="errors.fields.includes(key)"
          :errors="errors[key]"
          :onlyOneField="true"
        />
      </div>
      <div class="auth-form__actions">
        <div class="auth-form__actions-group">
          <SubmitBtn
            class="auth-form__actions-submit-wrapper auth-form__actions-submit-wrapper--login"
            extraButtonClasses="auth-form__actions__submit"
            iconName="person"
            title="Confirm"
          />
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { validateForm, clearFormErrors } from '@/helpers'
import Title from '@/components/forms/elements/Title.vue'
import Errors from '@/components/forms/elements/Errors.vue'
import SubmitBtn from '@/components/forms/elements/SubmitBtn.vue'

export default {
  name: 'ManageConfirmationForm',
  components: {
    Title,
    Errors,
    SubmitBtn,
  },
  data() {
    return {
      errors: clearFormErrors(),
      fields: {
        email: {
          type: 'email',
          placeholder: 'Email',
          rules: ['presence', 'email'],
          value: '',
          autocomplete: 'email',
        },
      },
    }
  },
  methods: {
    async validateFields() {
      const { fields } = this
      const { isValid, errors } = validateForm(fields)
      this.errors = errors
      if (isValid) {
        await this.submitForm(fields.email.value)
      }
    },
    async submitForm(email) {
      this.$emit('handle-loading', true)
      await this.$store.dispatch('admin/adminConfirmUser', email)
      this.$emit('handle-loading', false)
    },
    clearErrors() {
      this.errors = clearFormErrors()
    },
  },
}
</script>
